import React from 'react';

import { type CardSizes } from '@pkg/components';

import {
    BigName,
    Bottom,
    Button,
    ButtonGroup,
    Info,
    LittleName,
    Media,
    NameGroup,
    OwnerYat,
    Thumbnail,
    Top,
    Wrapper,
} from './styles';

interface CardSkeletonLoaderProps {
    disableTop?: boolean;
    cardSize?: CardSizes;
}

export const CardSkeletonLoader = ({ disableTop, cardSize }: CardSkeletonLoaderProps) => {
    return (
        <Wrapper $cardSize={cardSize}>
            {!disableTop && cardSize !== 'small' && (
                <Top>
                    <OwnerYat />
                </Top>
            )}
            <Media />
            <Info $cardSize={cardSize}>
                {cardSize !== 'small' && <Thumbnail />}
                <NameGroup>
                    <BigName />
                    {cardSize !== 'small' && <LittleName />}
                </NameGroup>
            </Info>
            <Bottom>
                <ButtonGroup>
                    <Button />
                </ButtonGroup>
                <ButtonGroup>
                    <Button />
                    <Button />
                </ButtonGroup>
            </Bottom>
        </Wrapper>
    );
};
